import { Component } from 'react';

import { AppState } from '../../AppState';
import { HubSpotFormState } from './HubSpotFormState';
import { HubSpotFormV2 } from './HubSpotFormV2';
import { HubSpotFormV4 } from './HubSpotFormV4';

export interface HubSpotFormPageProps<T> {
  appState: AppState;
  state: T;
}

export abstract class HubSpotFormPage<T extends HubSpotFormState> extends Component<HubSpotFormPageProps<T>> {
  protected abstract get initialFormData(): Record<string, string>;

  protected onFormSubmissionSuccess(_data: Record<string, string | string[]>): void {
    // No-op by default
  }

  public render() {
    const { appState, state } = this.props;

    if (state.hubSpotConfig.formVersion === '4') {
      return (
        <HubSpotFormV4
          appState={appState}
          state={state}
          initialFormData={this.initialFormData}
          onFormSubmissionSuccess={(data) => this.onFormSubmissionSuccess(data)}
        />
      );
    }

    return (
      <HubSpotFormV2
        appState={appState}
        initialFormData={this.initialFormData}
        state={state}
        onFormSubmit={(data) => this.onFormSubmissionSuccess(data)}
      />
    );
  }
}
